import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const WaivePrepaymentFeeModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  waivePrepaymentFee, waivePrepaymentError, onWaivePrepaymentChange,
  booleanList
}) =>
  <ModalFormUI
    context={context}
    titleLabel=''
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectUI name='waivePrepaymentFee' value={waivePrepaymentFee} required={true}
      label='Waive Prepayment Fee' optionList={booleanList}
      onChange={onWaivePrepaymentChange} error={waivePrepaymentError}
    />
  </ModalFormUI>

export default WaivePrepaymentFeeModalUI
